import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { nfcService } from '../../services/nfcService';
import { Spinner } from '../../components/ui/Spinner';
import { Button } from '../../components/ui/Button';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

export const NfcRedirect = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(false);

  useEffect(() => {
    const resolveNfc = async () => {
      try {
        const slug = await nfcService.resolveToken(token);
        if (slug) {
          // Pass source tracking context to the public card.
          // Note: We deliberately exclude the raw token from the URL to keep it out of analytics metadata.
          navigate(`/c/${slug}?source=nfc`, { replace: true });
        } else {
          setError(true);
        }
      } catch (err) {
        setError(true);
      }
    };

    if (token) resolveNfc();
  }, [token, navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 px-4 text-center">
        <div className="w-16 h-16 bg-slate-200 text-slate-400 rounded-full flex items-center justify-center mb-6">
          <SafeIcon icon={FiIcons.FiSmartphone} className="text-3xl" />
        </div>
        <h1 className="text-2xl font-bold text-slate-900 mb-2">This NFC link is no longer active.</h1>
        <p className="text-slate-600 max-w-md mx-auto mb-8">
          The owner may have updated or disabled this link.
        </p>
        <div className="flex gap-4">
          <Link to="/">
            <Button>Visit Meetoi</Button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex justify-center items-center bg-slate-50">
      <Spinner size="lg" />
    </div>
  );
};